<template>
    <div ref="icon" class="ys-float-btn" :class="showShaper ? '' : 'closeShaper'"
        :style="{ 'width': itemWidth + 'px', 'height': itemHeight + 'px', 'left': left + 'px', 'top': top + 'px' }"
        @mousedown="onMouseDown" @touchstart="onTouchStart">
        <i class="close" @click="closeShaper">X</i>
    </div>
</template>

<script>
export default {
    name: "DragIcon",
    data() {
        return {
            showShaper: true,
            timer: null,
            currentTop: 0,
            clientWidth: 0, // 屏幕宽度
            clientHeight: 0, // 屏幕高度
            left: 0,
            top: 0,
            isDragging: false,
            startX: 0,
            startY: 0,
            initialLeft: 0,
            initialTop: 0
        }
    },
    props: {
        itemWidth: { // 悬浮物的宽度
            type: Number,
            default: 40
        },
        itemHeight: {  // 悬浮物的高度
            type: Number,
            default: 40
        },
        gapWidth: { // 距离边界距离
            type: Number,
            default: 10
        },
        gapWidthHide: { // 距离边界多少时可以缩进
            type: Number,
            default: 20
        },
        hideWidth: { // 边界缩进隐藏的长度
            type: Number,
            default: 20
        },
        coefficientHeight: { // 计算 距离屏幕上边界高度的百分比
            type: Number,
            default: 0.8
        }
    },
    created() {
        // 初始化
        this.clientWidth = document.documentElement.clientWidth; // 屏幕宽度
        this.clientHeight = document.documentElement.clientHeight; // 屏幕高度
        this.left = this.clientWidth - this.hideWidth; // 初始为右侧缩进状态
        this.top = this.clientHeight * this.coefficientHeight; // 距离屏幕上边界80%的高度
    },
    mounted() {
        this.$nextTick(() => {
            const div = this.$refs.icon;
            // 触摸开始事件，阻止事件冒泡并取消过渡效果，让拖动更平滑
            div.addEventListener("touchstart", (e) => {
                e.stopPropagation();
                div.style.transition = 'none';
                this.onTouchStart(e);
            });
            // 悬浮物移动的过程展示，处理触摸移动事件
            div.addEventListener("touchmove", (e) => {
                if (this.isDragging) {
                    e.stopPropagation();
                    let touch = e.targetTouches[0];
                    this.left = touch.clientX - this.itemWidth / 2;
                    this.top = touch.clientY - this.itemHeight / 2;
                }
            }, false);
            // 悬浮物最后被移动到的位置，处理触摸结束事件
            div.addEventListener("touchend", (e) => {
                e.stopPropagation();
                div.style.transition = 'all 0.3s';
                this.onTouchEnd();
            });
        });
    },
    methods: {
        closeShaper() {
            this.showShaper = false;
        },
        onMouseDown(event) {
            event.preventDefault();
            this.isDragging = true;
            this.startX = event.clientX;
            this.startY = event.clientY;
            this.initialLeft = this.left;
            this.initialTop = this.top;
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        },
        onMouseMove(event) {
            if (this.isDragging) {
                this.left = this.initialLeft + event.clientX - this.startX;
                this.top = this.initialTop + event.clientY - this.startY;
            }
        },
        onMouseUp() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
            if (this.left > this.clientWidth / 2) { // 悬浮物最后位置的处理逻辑与触摸结束一致
                this.left = Math.min(this.left, this.clientWidth - this.gapWidth);
            } else {
                this.left = this.gapWidth;
            }
            if (this.top <= 36) {
                this.top = 36 + this.gapWidth;
            } else {
                let bottom = this.clientHeight - 50 - this.itemHeight;
                if (this.top >= bottom) {
                    this.top = bottom;
                }
            }
        },
        onTouchStart(e) {
            this.isDragging = true;
            let touch = e.targetTouches[0];
            this.startX = touch.clientX;
            this.startY = touch.clientY;
            this.initialLeft = this.left;
            this.initialTop = this.top;
        },
        onTouchEnd() {
            this.isDragging = false;
            if (this.left > this.clientWidth / 2) { // 悬浮物最后位置的处理逻辑与触摸结束一致
                this.left = Math.min(this.left, this.clientWidth - this.gapWidth);
            } else {
                this.left = this.gapWidth;
            }
            if (this.top <= 36) {
                this.top = 36 + this.gapWidth;
            } else {
                let bottom = this.clientHeight - 50 - this.itemHeight;
                if (this.top >= bottom) {
                    this.top = bottom;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.closeShaper {
    display: none !important;
}

.ys-float-btn::after {
    content: "公众号(扫一扫)";
    width: 100%;
    height: 2vw;
    background: white;
    position: absolute;
    bottom: -2vw;
    font-size: 0.8vw;
    font-family: 宋体;
    line-height: 2vw;
    left: 0;
    text-align: center;
}

.close {
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 50%;
    background: #efefef;
    position: absolute;
    top: -0.5vw;
    font-size: 2vw;
    right: -0.5vw;
    font-size: 1vw;
    line-height: 1.5vw;
    text-align: center;
}

.close:hover {
    background: white !important;
}

.ys-float-btn:hover {
    cursor: pointer;
}

.ys-float-btn {
    animation: fadeInRight 2s ease forwards;
    margin-bottom: 0.77rem;
    background: url('../../src/assets/img/ercode.jpg') no-repeat right; // 背景色或背景
    background-size: 100% 100%;

    // box-shadow:0 2px 10px 0 rgba(0,0,0,0.1); // 圆形球体图标的投影
    // border-radius:50%; // 制作圆形图标
    color: #666666;
    z-index: 20;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20vw;

    img {
        width: 50%;
        height: 50%;
        object-fit: contain;
        margin-bottom: 3px;
    }
}

.su_img {
    width: 40px;
    height: 40px;
    margin: 8px 0 0 0;
}

@keyframes fadeInRight {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}
</style>